/* unplugin-vue-components disabled */import { render } from "./popupBack.vue?vue&type=template&id=8b44d460&scoped=true"
import script from "./popupBack.vue?vue&type=script&lang=js"
export * from "./popupBack.vue?vue&type=script&lang=js"

import "./popupBack.vue?vue&type=style&index=0&id=8b44d460&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b44d460"]])

export default __exports__